export const getAllNotifications = {
  pathname: (orgId) => `/api/v4/cns/v1/groups/${orgId}/settings`
}

export const getNotification = {
  pathname: ({ path }) => `/api/v4/cns/v1/${path}`,
}

export const createNotification = {
  pathname: ({ orgId }) => `/api/v4/cns/v1/groups/${orgId}/settings`,
  method: 'POST',
  body: ({ _, payload }) => JSON.stringify(payload)
}

export const deleteNotification = {
  pathname: ({ path }) => `/api/v4/cns/v1/${path}`,
  method: 'DELETE',
  headers: {
    'content-type': 'application/json',
  }
}

export const updateNotification = {
  pathname: ({ path }) => `/api/v4/cns/v1/${path}?update_mask=config,display_name,enable_direct_send,enable_job,owners,recipients,schedules`,
  method: 'PATCH',
  headers: {
    'content-type': 'application/json',
  },
  body: ({ payload }) => JSON.stringify(payload)
}
